import React from "react";
import { useParams, Link } from "react-router-dom";
import { MapPin, Phone, Clock, Star, ExternalLink, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";

const LocationDetail = () => {
  const { locationName } = useParams();

  const locationData = {
    "navi-mumbai": {
      name: "Apply My Passport – Navi Mumbai",
      address: "2, Plot, no. 28, Rajkamal Bayside, 202, Wing, Sector 15, CBD Belapur, Navi Mumbai, Maharashtra 400614, India",
      phone: "+91 87795 19634",
      hours: "Open ⋅ Closes 10:30 PM",
      mapUrl: "https://maps.app.goo.gl/RRc1DMagCPnw1zEs7",
      mapEmbed: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3772.2989927924373!2d73.0292389747191!3d19.0065421541504!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c398ececbbd5%3A0x5b18bc3706b08a03!2sApply%20My%20Passport!5e0!3m2!1sen!2sae!4v1756384231421!5m2!1sen!2sae" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
      specialNote: "Fresh Passport: Get Your Passport in 2 Days*"
    },
    "pydhonie": {
      name: "Apply My Passport – Pydhonie",
      address: "10, Tawakkal Building, 21, Kolsa St, Nakhuda Mohalla, Pydhonie, Bhuleshwar, Mumbai, Maharashtra 400003, India",
      phone: "+91 98195 47890",
      hours: "Open ⋅ Closes 11 PM",
      mapUrl: "https://maps.app.goo.gl/8JEuXm2xDWMPTCZR8",
      mapEmbed: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9117.334354922972!2d72.8220921727997!3d18.955638820463857!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7cf5990f2fa73%3A0xbd24e7e3595e6c05!2sApply%20My%20Passport!5e0!3m2!1sen!2sza!4v1761749867280!5m2!1sen!2sza" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
      specialNote: "Fresh Passport: Get Your Passport in 2 Days*"
    },
    "santacruz": {
      name: "Apply My Passport – Santacruz",
      address: "B - 704, Sagar Avenue, Rustumbha Patuck Marg, Vakola Bridge, Santacruz East, Mumbai, Maharashtra 400055, India",
      phone: "+91 9619847890",
      hours: "Open ⋅ Closes 10:30 PM",
      mapUrl: "https://maps.app.goo.gl/V3PPYrFRACHuEdq47",
      mapEmbed: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.5835448018283!2d72.8463522747209!3d19.082039451783817!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9007eaf9b49%3A0xd208d12f82cc81fb!2sApply%20My%20Passport!5e0!3m2!1sen!2sae!4v1756384171221!5m2!1sen!2sae" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
      areasServed: "Bandra West and nearby areas",
      specialNote: "Fresh Passport: Get Your Passport in 2 Days*"
    },
    "mankhurd": {
      name: "Apply My Passport – Mankhurd",
      address: "Shop No. 16, 1st Floor, J Sector, B - Line, Cheeta Camp, Trombay, Mumbai, Maharashtra 400088, India",
      phone: "+91 84240 08891",
      hours: "Open ⋅ Closes 11 PM",
      mapUrl: "https://maps.app.goo.gl/DedF9w6MiAx34ZWj7",
      mapEmbed: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.5946305059206!2d72.947155!3d19.0375762!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c536eb97b4a5%3A0xa363096b850ff0b2!2sApply%20My%20Passport!5e0!3m2!1sen!2sae!4v1756384098797!5m2!1sen!2sae" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
      specialNote: "Fresh Passport: Get Your Passport in 2 Days*"
    },
    "vikhroli": {
      name: "Apply My Passport – Vikhroli",
      address: "E-703. Crescent Hill View, L.B.S Road Ghatkopar Vikhroli, Road, near Surya Nagar, Vikhroli West, Mumbai, Maharashtra 400083, India",
      phone: "+91 7977084003",
      hours: "Open ⋅ Closes 10:30 PM",
      mapUrl: "https://maps.app.goo.gl/bDoGNhvDj793oycf9",
      mapEmbed: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.544455343!2d72.92249237472133!3d19.081735451788773!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c79460463129%3A0x4db7b6634835ef56!2sApply%20My%20Passport!5e0!3m2!1sen!2sin!4v1728563421000!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
      specialNote: "Fresh Passport: Get Your Passport in 2 Days*"
    }
  };

  const services = [
    "Tatkal Passport", "Fresh Passport", "Passport Renewal", "Urgent Passport",
    "Lost Passport", "Damaged Passport", "Minor Passport", "ECNR Passport", "Police Clearance Certificate"
  ];

  const handleServiceClick = (serviceName) => {
    const message = encodeURIComponent(`I would like to enquire about ${serviceName}`);
    window.open(`https://wa.me/917977084003?text=${message}`, "_blank");
  };

  const getServiceIcon = (service) => {
    const iconMap = {
      "Tatkal Passport": "⚡",
      "Fresh Passport": "📄",
      "Passport Renewal": "🔄",
      "Urgent Passport": "⏰",
      "Lost Passport": "🔍",
      "Damaged Passport": "🛠️",
      "Minor Passport": "👶",
      "ECNR Passport": "🌐",
      "Police Clearance Certificate": "🏅"
    };
    return iconMap[service] || "📄";
  };

  const testimonials = locationName === "santacruz" ? [
    {
      name: "Soumya Bhat",
      text: "Splendid job. Got my passport in 2 days — feeling delighted :)",
      rating: 5
    },
    {
      name: "Rosemaria Paulose",
      text: "Apply My Passport was of great help… Mr. Sameer was very patient and guided me through the entire process.",
      rating: 5
    },
    {
      name: "Vidisha P",
      text: "Totally recommend Apply My Passport… Got my passport in a day's time. Excellent service!",
      rating: 5
    },
    {
      name: "Vivek Thomas",
      text: "Wanna get your passport hassle-free? I got mine in just a couple of days. Truly professional service.",
      rating: 5
    }
  ] : [
    {
      name: "Ankit Shah",
      text: "Fast, reliable, and stress-free passport application process. Highly recommended.",
      rating: 5
    },
    {
      name: "Priya Menon",
      text: "The team explained everything clearly and handled all the paperwork. Couldn't have been easier.",
      rating: 5
    },
    {
      name: "Raj Patel",
      text: "Excellent service and quick processing. Got my passport without any hassle.",
      rating: 5
    },
    {
      name: "Meera Singh",
      text: "Professional staff and efficient service. Highly satisfied with the experience.",
      rating: 5
    }
  ];

  const location = locationData[locationName];

  if (!location) {
    return (
      <div className="min-h-screen bg-gray-50 py-12 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Location Not Found</h1>
          <p className="text-gray-600">The requested location could not be found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">{location.name}</h1>
          {location.specialNote && (
            <Badge className="bg-green-600 text-white text-base px-4 py-2">
              {location.specialNote}
            </Badge>
          )}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-8">
            {/* Contact Information */}
            <Card>
              <CardHeader>
                <CardTitle>Contact Information</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="flex items-start space-x-3">
                  <MapPin className="h-5 w-5 text-gray-600 mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-medium text-gray-900">Address</p>
                    <p className="text-gray-600">{location.address}</p>
                    {location.areasServed && (
                      <p className="text-sm text-gray-500 mt-1">Areas served: {location.areasServed}</p>
                    )}
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  <Phone className="h-5 w-5 text-gray-600" />
                  <div>
                    <p className="font-medium text-gray-900">Phone Number</p>
                    <a 
                      href={`tel:${location.phone}`}
                      className="text-blue-600 hover:text-blue-800 font-medium"
                    >
                      {location.phone}
                    </a>
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  <Clock className="h-5 w-5 text-gray-600" />
                  <div>
                    <p className="font-medium text-gray-900">Office Timings</p>
                    <p className="text-gray-600">{location.hours}</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Services */}
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center justify-between">
                  Services Available
                  <Link to="/services">
                    <Button variant="outline" size="sm">
                      View All Details
                      <ArrowRight className="ml-1 h-4 w-4" />
                    </Button>
                  </Link>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {services.map((service, index) => (
                    <div 
                      key={index} 
                      onClick={() => handleServiceClick(service)}
                      className="text-center p-4 bg-blue-50 rounded-lg border border-blue-100 hover:bg-blue-100 transition-all duration-200 cursor-pointer hover:scale-105"
                    >
                      <div className="text-2xl mb-2">
                        {getServiceIcon(service)}
                      </div>
                      <p className="text-sm font-medium text-gray-900 mb-1">{service}</p>
                      <p className="text-xs text-green-600 font-medium">Click to enquire</p>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>

            {/* Google Map */}
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center justify-between">
                  Location Map
                  <a 
                    href={location.mapUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center text-blue-600 hover:text-blue-800 text-sm"
                  >
                    Open in Google Maps
                    <ExternalLink className="ml-1 h-4 w-4" />
                  </a>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="aspect-video rounded-lg overflow-hidden">
                  <div 
                    dangerouslySetInnerHTML={{ __html: location.mapEmbed }}
                    className="w-full h-full [&>iframe]:w-full [&>iframe]:h-full"
                  />
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Sidebar */}
          <div className="space-y-8">
            {/* Quick Actions */}
            <Card>
              <CardHeader>
                <CardTitle>Quick Actions</CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                <a href={`tel:${location.phone}`}>
                  <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white">
                    <Phone className="mr-2 h-4 w-4" />
                    Call Now
                  </Button>
                </a>
                <a 
                  href="https://wa.me/917977084003" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <Button variant="outline" className="w-full bg-green-50 border-green-200 text-green-700 hover:bg-green-100">
                    WhatsApp Chat
                  </Button>
                </a>
                <a 
                  href={location.mapUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button variant="outline" className="w-full">
                    <MapPin className="mr-2 h-4 w-4" />
                    Get Directions
                  </Button>
                </a>
              </CardContent>
            </Card>

            {/* Client Testimonials */}
            <Card>
              <CardHeader>
                <CardTitle>Client Testimonials</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="border-b border-gray-200 pb-4 last:border-b-0 last:pb-0">
                    <div className="flex items-center mb-2">
                      <div className="flex text-yellow-400">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <Star key={i} className="h-4 w-4 fill-current" />
                        ))}
                      </div>
                    </div>
                    <p className="text-gray-600 text-sm mb-2">"{testimonial.text}"</p>
                    <p className="text-gray-900 font-medium text-sm">- {testimonial.name}</p>
                  </div>
                ))}
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationDetail;